// extracted by mini-css-extract-plugin
export default {"outerProgressContainer":"CardProgress_outerProgressContainer__qzO5L"};